
import { Component, OnInit, ViewChild, ElementRef, OnDestroy, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';

import { CapabilitiesService } from '../../features/capabilities/capabilities.service';
import { ToastrService } from 'ngx-toastr';

import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonService } from '../../_services/common.service';
import { ValidationService } from '../../_services/validation.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-manage',
  templateUrl: './capability.component.html',
  styleUrls: ['./capability.component.scss']
})
export class CapabilityComponent implements OnInit, OnDestroy {
  capabilityForm!: FormGroup;
  @Output() response: EventEmitter<boolean> = new EventEmitter();
  subscription!: Subscription;

  capabilityTypes: any = ['custom', 'crud'];
  selectedModule: any;
  crudOption = ['add', 'update', 'list', 'delete'];
  public targets = ['_blank', '_self'];
  types: any = {
    add: false,
    update: false,
    list: false,
    delete: false
  };
  isValidateAll = true;
  capabilityType: String = 'custom';
  modules: any[] = [];
  submitted!: boolean;
  isSubmitted: any;
  selectedOptions: any;

  constructor(
    private fb: FormBuilder,
    private capabilitiesService: CapabilitiesService,
    private toastrService: ToastrService,
    public dialogRef: MatDialogRef<CapabilityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.capabilityForm = this.fb.group({
      capabilityType: new FormControl('custom'),
      name: new FormControl('', Validators.compose([ValidationService.required])),
      selectedModule: new FormControl('', Validators.compose([ValidationService.required]))
    });
  }

  ngOnInit() {

    this.submitted = false;
    this.capabilitiesService.getModules().subscribe({
      next: (result: any) => {
        if (result && result.success) {
          this.modules = result.data;
        }
      },
      error: (error: any) => {
        this.toastrService.error(error);
      }
    });
    this.capabilityType = this.capabilityTypes[0];
  }

  selecteType(type: any) {
    this.capabilityType = type;
    this.types = {
      add: false,
      update: false,
      list: false,
      delete: false
    };
  }

  checkboxChange(op: any, event: any) {
    this.types[op] = Boolean(event?.checked);
  }

  saveCapability() {
    this.submitted = true;
    this.isValidateAll = true;

    if (this.capabilityType) {
      if (this.capabilityType === 'crud') {
        let isCheckedAny: boolean = false;
        this.crudOption.forEach((element) => {
          if (this.types[element]) {
            isCheckedAny = true;
          }
        });
        if (!isCheckedAny) {
          this.isValidateAll = false;
          this.toastrService.error('Please select at least 1 capability');
        }
      } else {
        if (!this.capabilityForm.get('name')?.value) {
          this.isValidateAll = false;
          this.toastrService.error('Please enter name');
        }
      }
    } else {
      this.isValidateAll = false;
      this.toastrService.error('Please fill required fields');
    }

    if (!this.capabilityForm.get('selectedModule')?.value && this.isValidateAll) {
      this.isValidateAll = false;
      this.toastrService.error('Please select module');
    }

    if (this.isValidateAll) {
      // let obj: any;
      const obj:any = {
        type: this.capabilityType,
        name: this.capabilityType === 'custom' ? this.capabilityForm.get('name')?.value : '',
        module: this.capabilityForm.get('selectedModule')?.value,
        types: this.types
      };
      this.capabilitiesService.saveCapabilities(obj).subscribe({
        next: (res: any) => {
          if (res && res.success) {
            this.dialogRef.close(res);
          } else {
            this.submitted = false;
            this.toastrService.error(res.message);
          }
        },
        error: (err: any) => {
          this.toastrService.error(err?.error?.message || "Capability already exists with given name");
        }
      });
    }
  }
  close() {
    this.dialogRef.close();
  }
  ngOnDestroy() { }

}